import {defineStore} from "pinia";
import {api} from '@/api/client';
import {useAppDataStore} from "@/stores/app-data";

export const useUxData = defineStore('uxData', {
    state: () => ({
        labels: null as any,
        plans: [] as any[],
        currentPlan: null as any,
    }),
    getters: {
        swadeRanks: (state) => {
            return [
                {
                    label: state.labels.swade.rank.novice,
                    key: 'novice',
                },
                {
                    label: state.labels.swade.rank.seasoned,
                    key: 'seasoned',
                },
                {
                    label: state.labels.swade.rank.veteran,
                    key: 'veteran',
                },
                {
                    label: state.labels.swade.rank.heroic,
                    key: 'heroic',
                },
                {
                    label: state.labels.swade.rank.legendary,
                    key: 'legendary',
                },
            ]
        },
        swadePowerStyles: (state) => {
            return [
                {
                    label: state.labels.swade.powerStyles.standard,
                    key: 'standard',
                },
                {
                    label: state.labels.swade.powerStyles.superpower,
                    key: 'superpower',
                },
                // {
                //     label: state.labels.swade.powerStyles.innate,
                //     key: 'innate',
                // },
            ]
        },
        swadeAdvantageTypes: (state) => {
          const keys = Object.keys(state.labels.swade.data.edges.types);
          return keys.filter((key: string) => key !== 'uncategorized').map((key: string) =>
          {
              return {
                  label: state.labels.swade.data.edges.types[key],
                  value: key,
              }
          })
        },
    },
    actions: {
        async fetchUxLabels() {
            await api.get('/ux/labels', {
                    headers: {}
                })
                .then((response) => {
                    this.labels = response.data;
                })
        },
        async fetchSubscriptionPlans() {

        }
    }
})
